"use strict";var s=require("./__bundle-43187895.js");class t extends s.User{constructor(s,t){var e;super(s,t),this.isMuted=!1,this.isMuted=null!==(e=t.is_muted)&&void 0!==e&&e}}exports.Participant=t;
